import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: ${(props) => (props.selected ? "#ffb81c" : "white")};
  aspect-ratio: 1/1;
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  margin: 10px;
  text-align: center;
  &:hover {
    background-color: #ffb81c;
    cursor: pointer;
  }
`;

export const CardText = styled.span`
  color: ${(props) => (props.selected ? "#003865" : "grey")};
  margin-top: auto;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  ${Wrapper}:hover & {
    color: #003865;
  }
  @media only screen and (max-width: 1350px) {
    font-size: 16px;
  }
`;
